import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';

export const SUPPORTED_LOCALES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية' },
];

const RTL_LOCALES = ['ar'];

export function isRTLLocale(locale) {
  return RTL_LOCALES.includes(locale);
}

/**
 * Apply <html lang="..." dir="..."> for the active locale. Browsers
 * handle bidi text and CSS logical-property flipping automatically
 * once dir="rtl" is set.
 */
export function applyHtmlDirection(locale) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('lang', locale);
  document.documentElement.setAttribute('dir', isRTLLocale(locale) ? 'rtl' : 'ltr');
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      pt: { translation: pt },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'pt', 'ar'],
    nonExplicitSupportedLngs: true, // matches "fr-CA" → "fr", "ar-AE" → "ar"
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'app_locale',
    },
  })
  .then(() => applyHtmlDirection(i18n.language));

i18n.on('languageChanged', (lng) => {
  applyHtmlDirection(lng);
});

export default i18n;
